import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SettingsService } from '../../../core/settings/settings.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { TranslatorService } from '../../../core/translator/translator.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {

  token: string
  passwordForm: FormGroup;
  selectedLanguage: string;

  langs: Promise<{ code: string, text: string }[]>;

  private routeSubscription: Subscription;

  constructor(private route: ActivatedRoute, fb: FormBuilder, public settings: SettingsService, private translator: TranslatorService, private router: Router) {
    this.routeSubscription = route.params.subscribe(params => { this.token = params['token'] })
    this.translator.useLanguage();

    let password = new FormControl('', Validators.compose([Validators.required, Validators.pattern('^(?=.*[a-z])(?=.*[A-Z]).{6,60}$')]));
    let certainPassword = new FormControl('', [Validators.required, CustomValidators.equalTo(password), Validators.pattern('^(?=.*[a-z])(?=.*[A-Z]).{6,60}$')]);

    this.passwordForm = fb.group({
      'password': password,
      'confirmPassword': certainPassword
    });

  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.routeSubscription) this.routeSubscription.unsubscribe();
  }

  submitForm($ev, value: any) {
    $ev.preventDefault();

    for (let c in this.passwordForm.controls) {
      this.passwordForm.controls[c].markAsTouched();
    }

    if (this.passwordForm.valid) {
      this.resetPassword(this.token, this.passwordForm.controls['password'].value)
    }

    if (this.routeSubscription) this.routeSubscription.unsubscribe();
  }

  resetPassword(token: string, newPassword: string) {
    Accounts.resetPassword(token, newPassword, (err) => {
      if (err) {
        console.log("Login failed! " + err);        
      } else {
        this.router.navigate(['/login']);
      }
    })
  }
}
